import { render, staticRenderFns } from "./AppointmentSummaryComponent.vue?vue&type=template&id=55b4133e&"
import script from "./AppointmentSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./AppointmentSummaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports